import React from 'react';
import { PARTICIPANT_STATUS_ONLINE } from 'common-data-handling';
import { usePartiallyMatchedParticipants } from '../../../../../data/hooks/participant/usePartiallyMatchedParticipants';
import { useRecommendedParticipantsFilter } from '../../../../../data/hooks/participant/useRecommendedParticipantsFilter';
import { PartialMatchesList } from '../../../../elements/ParticipantsList';
import EmptyParticipantsListMessage from '../EmptyParticipantsListMessage';

const SORT_SUGGESTED_PARTICIPANTS = [p => (!!p.user_id ? -1 : 0), p => (p.status == PARTICIPANT_STATUS_ONLINE ? -1 : 0), 'sortstring'];

function SuggestedParticipantsList(props) {
    const {className = '', eventId} = props,
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId),
        [participants, busy] = usePartiallyMatchedParticipants(eventId, suggestedFilterParams);

    if (!participants.length && !busy) {
        return <EmptyParticipantsListMessage filterParams={{}} suggestedFilterParams={suggestedFilterParams} />;
    }

    return <PartialMatchesList className={className} list={participants} busy={busy} sortBy={SORT_SUGGESTED_PARTICIPANTS} />;
}

export default SuggestedParticipantsList;